import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Header from "@/components/Header";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import HistoryPage from "@/pages/HistoryPage";
import RulesPage from "@/pages/RulesPage";
import BillingPage from "@/pages/BillingPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";

function ProtectedLayout({ children }) {
  return (
    <ProtectedRoute>
      <div className="App min-h-screen bg-black">
        <Header />
        {children}
      </div>
    </ProtectedRoute>
  );
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (!user || typeof user !== "object") return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<ProtectedLayout><DashboardPage /></ProtectedLayout>} />
          <Route path="/history" element={<ProtectedLayout><HistoryPage /></ProtectedLayout>} />
          <Route path="/rules" element={<ProtectedLayout><RulesPage /></ProtectedLayout>} />
          <Route path="/billing" element={<ProtectedLayout><BillingPage /></ProtectedLayout>} />
          <Route path="/billing/success" element={<ProtectedLayout><Navigate to="/billing?returned=1" replace /></ProtectedLayout>} />
          <Route path="/billing/cancel" element={<ProtectedLayout><Navigate to="/billing?cancelled=1" replace /></ProtectedLayout>} />
          <Route path="/profile" element={<ProtectedLayout><ProfilePage /></ProtectedLayout>} />
          <Route path="/admin" element={<ProtectedLayout><AdminOnly><AdminPage /></AdminOnly></ProtectedLayout>} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
